<script setup>
import { computed } from 'vue'

const props = defineProps({
  content: { type: Object, required: true },
  variant: { type: String, default: 'gallery-02' },
})

const images = computed(() => props.content.images?.value ?? [])
</script>

<template>
  <section class="b2-gallery-showcase">
    <div class="b2-showcase-heading">
      <div>
        <div class="b2-section-label">{{ content.label.value }}</div>
        <h2 class="b2-section-title">{{ content.title.value }}</h2>
      </div>
      <span class="b2-image-count">{{ images.length }} projects</span>
    </div>

    <div v-if="images.length" class="b2-showcase-layout">
      <figure class="b2-featured-image">
        <img :src="images[0].url" :alt="images[0].caption" />
        <figcaption>{{ images[0].caption }}</figcaption>
      </figure>

      <div class="b2-showcase-list">
        <figure v-for="(img, i) in images.slice(1)" :key="i">
          <img :src="img.url" :alt="img.caption" />
          <figcaption>{{ img.caption }}</figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<style scoped>
.b2-gallery-showcase { padding: 100px 40px; max-width: 1200px; margin: 0 auto; }
.b2-showcase-heading { display: flex; justify-content: space-between; align-items: end; gap: 24px; margin-bottom: 42px; }
.b2-section-label { font-size: 11px; font-weight: 500; letter-spacing: .2em; text-transform: uppercase; color: #4a8c3f; margin-bottom: 14px; }
.b2-section-title { font-family: 'Playfair Display', serif; font-size: clamp(30px, 4vw, 50px); font-weight: 700; color: #1a3320; line-height: 1.15; margin: 0; }
.b2-image-count { color: #6b756d; font-size: 13px; white-space: nowrap; }
.b2-showcase-layout { display: grid; grid-template-columns: minmax(0, 1.6fr) minmax(240px, .8fr); gap: 18px; }
.b2-featured-image, .b2-showcase-list figure { position: relative; overflow: hidden; margin: 0; border-radius: 4px; background: #e8eee6; }
.b2-featured-image { min-height: 560px; }
.b2-featured-image img, .b2-showcase-list img { width: 100%; height: 100%; object-fit: cover; display: block; transition: transform .5s ease; }
.b2-featured-image:hover img, .b2-showcase-list figure:hover img { transform: scale(1.04); }
.b2-showcase-list { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
.b2-showcase-list figure { min-height: 270px; }
figcaption { position: absolute; inset: auto 0 0; padding: 36px 16px 14px; color: #fff; font-size: 14px; background: linear-gradient(transparent, rgba(0,0,0,.72)); }
@media (max-width: 768px) {
  .b2-gallery-showcase { padding: 64px 20px; }
  .b2-showcase-layout { grid-template-columns: 1fr; }
  .b2-featured-image { min-height: 380px; }
}
@media (max-width: 520px) {
  .b2-showcase-heading { align-items: start; flex-direction: column; }
  .b2-showcase-list { grid-template-columns: 1fr; }
}
</style>
